import React, { useState } from "react";
import { FaCheck, FaLock } from "react-icons/fa";
import { putRequest } from "../../../helpers/api.helper";
import { toast } from "react-toastify";
import { normalizePrivacyValue } from "../../../utils/imagePrivacy";

type ImagePrivacyModalProps = {
  setIsImagePrivacyModalOpen: (open: boolean) => void;
  profile: any;
  setProfile: (profile: any) => void;
  imagePrivacyOptions: any;
};

const ImagePrivacyModal = ({
  setIsImagePrivacyModalOpen,
  profile,
  setProfile,
  imagePrivacyOptions,
}: ImagePrivacyModalProps) => {
  const [imagePrivacyLoading, setImagePrivacyLoading] = useState(false);

  const handleImagePrivacyChange = async (newValue: any) => {
    if (!profile) return;
    setImagePrivacyLoading(true);
    try {
      const res = await putRequest(`/bureau/profile/${profile?._id}`, {
        imagePrivacy: newValue,
      });
      if (res.success) {
        setProfile((prev: any) => ({ ...prev, imagePrivacy: newValue }));
        toast.success("Image privacy updated!");
        setIsImagePrivacyModalOpen(false);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      toast.error("Failed to update image privacy.");
    } finally {
      setImagePrivacyLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg p-6 w-96 max-w-md mx-4">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-bold flex items-center">
            <FaLock className="mr-2 text-purple-600" />
            Image Privacy
          </h2>
          <button
            onClick={() => setIsImagePrivacyModalOpen(false)}
            className="text-gray-500 hover:text-gray-700 text-xl"
          >
            ×
          </button>
        </div>
        <div className="space-y-3">
          {imagePrivacyOptions.map((opt: any) => (
            <button
              key={opt.value}
              onClick={() => handleImagePrivacyChange(opt.value)}
              disabled={imagePrivacyLoading}
              className={`w-full p-3 rounded-lg border-2 flex items-center justify-between transition-all ${
                normalizePrivacyValue(profile.imagePrivacy) ===
                normalizePrivacyValue(opt.value)
                  ? "border-purple-500 bg-purple-50"
                  : "border-gray-200 bg-gray-50 hover:border-purple-300"
              }`}
            >
              <span>{opt.label}</span>
              {normalizePrivacyValue(profile.imagePrivacy) ===
                normalizePrivacyValue(opt.value) && (
                <FaCheck className="text-purple-600" />
              )}
            </button>
          ))}
        </div>
        {imagePrivacyLoading && (
          <div className="text-center mt-4">
            <div className="inline-flex items-center">
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-purple-600 mr-2"></div>
              <span className="text-sm text-gray-600">Updating...</span>
            </div>
          </div>
        )}
        <div className="flex space-x-3 mt-6">
          <button
            onClick={() => setIsImagePrivacyModalOpen(false)}
            className="flex-1 px-6 py-3 bg-gray-200 text-gray-800 rounded-lg font-medium hover:bg-gray-300 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImagePrivacyModal;
